import { Card, StarRating } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import { MessageDescriptor } from '@/@types';
import { useLingui } from '@lingui/react';
import * as styles from './rating-card.styles';

const RatingCard: UIComponent<{ rating: { user: string; value: number; date: Date; message: MessageDescriptor } }> = ({ rating }) => {
  const { i18n } = useLingui();
  return (
    <Card className={styles.root}>
      <StarRating value={rating.value} />
      <span className={styles.user}>
        {rating.user}, {new Intl.DateTimeFormat(i18n.locale, { month: '2-digit', day: '2-digit', year: 'numeric' }).format(rating.date)}
      </span>
      <p>{i18n._(rating.message)}</p>
    </Card>
  );
};

export default RatingCard;
